import { atom } from "recoil";

export const ShowProgress = atom({
  key: "ShowProgress",
  default: false,
});
